const localizers = {
  'loading.msg': () => `A carregar...`,
  'SASServer.genericError.msg': () => `Não foi possível contactar o servidor.`,
  'SASReport.genericError.msg': () => `Não foi possível carregar o relatório selecionado.`,
  'SASReportImage.genericError.msg': () => `Falha ao carregar a imagem de relatório.`,
  'SASReportImage.imageNotSupported.msg': () => `Não são suportadas imagens para este tipo de conteúdo de relatório.`,
}
export default localizers;
